module.exports = __webpack_public_path__ + "static/img/ad.f710d0db.png";